import Search from '@engineering/icons/search';
import { useTranslations } from 'next-intl';
import {
  EmbeddedButton,
  FormContainer,
  Headline,
  SearchButton,
} from './Form.styles';

type Props = {
  searchAction?: () => void;
};

export const SearchForm = ({ searchAction }: Props) => {
  const t = useTranslations('features.stage');

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (searchAction) {
      searchAction();
    }
  };

  return (
    <FormContainer>
      <Headline>{t('search.headline')}</Headline>
      <SearchButton onClick={handleSubmit}>
        <Search height="24" />
        {t('search.input.placeholder')}
        <EmbeddedButton>{t('search.input.cta')}</EmbeddedButton>
      </SearchButton>
    </FormContainer>
  );
};
